var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPen = function SvgPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m14 12-.667.73a1.807 1.807 0 0 1-1.333.603c-.5 0-.98-.217-1.333-.604a1.81 1.81 0 0 0-1.334-.602c-.5 0-.979.216-1.333.602m-6 .604h1.116c.326 0 .49 0 .643-.037.136-.032.266-.086.385-.16.135-.082.25-.197.48-.427L13 4.333a1.414 1.414 0 1 0-2-2L2.625 10.71c-.23.23-.346.345-.429.48-.073.12-.127.25-.16.385-.036.154-.036.317-.036.643v1.116Z"
  })));
};
export default SvgPen;